export const initMap = (id, initBounds = false, initPop = true, zoom = 5, flyToFirstMarker = false) => {


	mapboxgl.accessToken = 'pk.eyJ1Ijoicm94eG1lZGlhIiwiYSI6ImNrMzc3bnR6OTA4czUzZnFlazExdnA4dDkifQ.pmrc6ANMxz7rSb3mVNR5tQ';
	const map = new mapboxgl.Map({
		container: id,
		style: 'mapbox://styles/roxxmedia/ck71xvzyd0u781io3adcsze33',
		center: [19.850339, 51.823583], // starting position [lng, lat]
		zoom: zoom,
		pitch: 20,
		//		bearing: 20,
		antialias: true
	});


	const bounds = new mapboxgl.LngLatBounds();
	map.scrollZoom.disable();
	map.addControl(new mapboxgl.NavigationControl());
	map.on('load', function () {
		map.addSource('places', {
			type: 'geojson',
			data: geojson
		});
	});

	addMarkers(map, bounds, initPop);
	if (initBounds) fitBounds(map, bounds);
	if (flyToFirstMarker) flyToStore(map, geojson.features[0]);

};



function addMarkers(map, bounds, initPop) {

	geojson.features.forEach(function (marker, i) {
		// Create a div element for the marker
		var el = document.createElement('div');
		// Add a class called 'marker' to each div
		el.className = 'marker';
		// By default the image for your custom marker will be anchored
		// by its top left corner. Adjust the position accordingly
		// Create the custom markers, set their position, and add to map
		new mapboxgl.Marker(el, {
				offset: [0, 0]
			})
			.setLngLat(marker.geometry.coordinates)
			.addTo(map);
		bounds.extend(marker.geometry.coordinates);
		el.addEventListener('click', function (e) {

			var link = marker.properties.link;
			if (link) {
				window.location.href = link;
			}
			//	var activeItem = document.getElementsByClassName('active');
			// 1. Fly to the point
			flyToStore(map, marker);
			// 2. Close all other popups and display popup for clicked store
			if (initPop) createPopUp(marker);
			// 3. Highlight listing in sidebar (and remove highlight for all other listings)
			e.stopPropagation();
			// if (activeItem[0]) {
			// 	activeItem[0].classList.remove('active');
			// }
		});

	})


	function createPopUp(currentFeature) {
		var popUps = document.getElementsByClassName('mapboxgl-popup');
		// Check if there is already a popup on the map and if so, remove it
		if (popUps[0]) popUps[0].remove();

		var popup = new mapboxgl.Popup({
				closeOnClick: false
			})
			.setMaxWidth("290px")
			.setLngLat(currentFeature.geometry.coordinates)
			.setHTML('<h3>' + currentFeature.properties.title + '</h3>' +
				'<h4>' + currentFeature.properties.description + '</h4>' +
				'<h4>' + currentFeature.properties.phone + '</h4>')
			.addTo(map);
		// popup.on('close', function (e) {
		// 	map.flyTo({
		// 		center: [19.850339, 51.823583], // starting position [lng, lat]
		// 		zoom: 10,
		// 	});
		// })
	}
}

function flyToStore(map, currentFeature) {
	map.flyTo({
		center: currentFeature.geometry.coordinates,
		zoom: 10
	});
}
// Fit map to the current markers
function fitBounds(map, bounds) {
	map.on('load', (e) => {
		map.fitBounds(bounds, {
			maxZoom: 15,
			padding: {
				top: 50,
				bottom: 50,
				left: 50,
				right: 50
			},
		});
	});
}